import { SidebarState } from '@slices/sidebar';

import { appCreateSelector, RootState } from '@store';

export const sidebarGet = (state: RootState): SidebarState => {
  return state.ui.sidebar;
};

export const sidebarGetIsOpen: (
  state: RootState //
) => boolean = appCreateSelector(
  [sidebarGet], //
  (sidebar) => sidebar.isOpen
);
